var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.745 22.4995H18.75V16.8745C18.75 16.1395 18.3188 15.472 17.6513 15.1682C16.98 14.8607 16.1925 14.9807 15.6413 15.4645L0.64125 28.5895C0.2325 28.9457 0 29.4595 0 29.9995C0 30.5395 0.2325 31.0532 0.64125 31.4095L15.6413 44.5345C16.1925 45.022 16.9837 45.1382 17.6513 44.8307C18.3188 44.527 18.75 43.8595 18.75 43.1245V37.4995H22.7475L32.745 22.4995Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3712 29.7185L58.3734 29.7204C58.4543 29.7909 58.5002 29.8918 58.5002 29.9996C58.5002 30.1074 58.4543 30.2083 58.3734 30.2788L58.3712 30.2807L43.3712 43.4057L43.3669 43.4095C43.3002 43.4684 43.2169 43.4996 43.1252 43.4996C43.0753 43.4996 43.0208 43.4886 42.9697 43.4653L42.9674 43.4643C42.8361 43.4049 42.7502 43.2741 42.7502 43.1246V37.4996V35.9996H41.2502H30.0544L38.0554 23.9996H41.2502H42.7502V22.4996V16.8746C42.7502 16.7269 42.8342 16.5973 42.9629 16.537C43.1089 16.4743 43.2672 16.5035 43.3731 16.5951C43.3734 16.5954 43.3737 16.5956 43.3739 16.5959L58.3712 29.7185Z",
    stroke: "#C4C4C4",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.7087340ae3688a038285a422646c5df1.svg";
export { ForwardRef as ReactComponent };